module.exports = __webpack_public_path__ + "static/media/cissp_logo.49026bf5.png";